import { getToken, registerToken } from 'api/tokenApi';
import { useLoginContext } from 'components/providers/loginContext';
import { useCallback, useState } from 'react';
import { RsiAuthorizeParameter } from 'api/tokenApi';

// ログインユーザーのリフレッシュトークンに関する処理を行う
export function useToken(): [
  () => Promise<void>,
  (rsiAuthorizeParameter: RsiAuthorizeParameter) => Promise<void>,
  boolean | undefined,
  boolean,
  any,
  any,
] {
  const loginContext = useLoginContext();
  const [exitToken, setExitToken] = useState<boolean | undefined>(undefined);
  const [getError, setGetError] = useState<any>(undefined);
  const [registerError, setRegisterError] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);

  const handleGetToken = useCallback(async (): Promise<void> => {
    try {
      if (loading) return;
      setLoading(true);

      // リフレッシュトークン取得
      const token = await getToken(loginContext);

      setGetError(undefined);
      setLoading(false);
      setExitToken(token.exitToken);
    } catch (e) {
      setGetError(e);
      setLoading(false);
      setExitToken(false);
    }
  }, [loading, loginContext]);

  const handleRegisterToken = useCallback(
    async (rsiAuthorizeParameter: RsiAuthorizeParameter): Promise<void> => {
      try {
        if (loading) return;
        setLoading(true);

        // リフレッシュトークン登録
        await registerToken(loginContext, rsiAuthorizeParameter);

        setRegisterError(undefined);
        setLoading(false);
      } catch (e) {
        setRegisterError(e);
        setLoading(false);
      }
    },
    [loading, loginContext],
  );

  return [
    handleGetToken,
    handleRegisterToken,
    exitToken,
    loading,
    getError,
    registerError,
  ];
}
